import dispatcher from '../dispatcher';
import scrollStore from './scroll.store';

const options = {
    selector: '.scroll-effect',
    classes: {
        show: 'is-shown',
        gone: 'is-gone',
        elements: ['scroll-effect', 'scroll-effect--group'],
        transitionElements: ['scroll-effect--fade', 'scroll-effect--fade-up'],
        afterShowElements: ['is-stop']
    },
    duration: 400
};

options.selector = '.' + options.classes.elements.join(', .');

class ScrollIntersectionAnimation {
	constructor() {
        this._active = false;
        this._elements = [];

        this.init = this.init.bind(this);
        this.destroy = this.destroy.bind(this);

        this.handleElement = this.handleElement.bind(this);

        this.handleIntersection = this.handleIntersection.bind(this);
        this.intersectionCallback = this.intersectionCallback.bind(this);
        this.disconnectIntersection = this.disconnectIntersection.bind(this);

        this.prepareElements = this.prepareElements.bind(this);

        this.afterShowIntersection = this.afterShowIntersection.bind(this);
        this.init();
    }

	init() {
        if (this._active)
            return;

        this.prepareElements();
        this.handleIntersection();

        this._active = true;
        dispatcher.addListener(this.handleDispatcher);
	}

    destroy() {
        if (!this._active)
            return;

        this._active = false;
        this.disconnectIntersection();
        dispatcher.removeListener(this.handleDispatcher);
    }

    handleElement(element) {
	    element.classList.add(options.classes.show);

        setTimeout(() => {
            /*
            element
                .querySelectorAll('.' + options.classes.transitionElements.join(', .'))
                .forEach(el => el.style.transitionDelay = null); */

            let delayEls = element.querySelectorAll('.' + options.classes.transitionElements.join(', .')),
                base = 0,
                increase = 50;

            Array.prototype.slice.call(delayEls, 0).reverse()
                .forEach((el, i) => {
                    el.style.transitionDelay = (Number(base) + (increase * i)) + 'ms';
                });
        }, options.duration);

        let deferAction = element.dataset.deferAction,
            deferActionDelay = element.dataset.deferActionDelay;

        if (deferAction) {
            setTimeout(() => {
                element.classList.add(deferAction);
            }, Number(deferActionDelay || 0));
        }
    }

    prepareElements() {
        this._elements = document.querySelectorAll(options.selector);

        document
            .querySelectorAll('[data-delay]')
            .forEach(el => {
                if (el.dataset.delay)
                    el.style.transitionDelay = el.dataset.delay + 'ms';
            });

        document
            .querySelectorAll('[data-delay-increase]')
            .forEach(element => {
                let base = element.dataset.delayBase,
                    increase = element.dataset.delayIncrease;

                element
                    .querySelectorAll('.' + options.classes.transitionElements.join(', .'))
                    .forEach((el, i) => {
                        el.style.transitionDelay = (Number(base) + (increase * i)) + 'ms';
                    });
            });
    }

    handleIntersection() {
        if ('IntersectionObserver' in window) {
            this.disconnectIntersection();

            this._observer = new IntersectionObserver(this.intersectionCallback, {
                threshold: 0,
                rootMargin: `0px 0px -${window.innerHeight / 4}px 0px`
            });

            this._elements.forEach(element => {
                this._observer.observe(element);
            });
        }
        else {
            this._elements.forEach(element => {
                this.handleElement(element);
            });
        }
    }

    intersectionCallback(entries) {
        entries.forEach(entry => {
            if (
                entry.intersectionRatio > 0 && // > .1 &&
                !!entry.isIntersecting &&
                !!entry.target.offsetParent
            ) {
                this._observer.unobserve(entry.target);
                this.handleElement(entry.target);
            }
        });
    }

    afterShowIntersection() {
        if ('IntersectionObserver' in window) {
            if (this._shownObserver)
                this._shownObserver.disconnect();

            this._shownElements =
                document.querySelectorAll(options.classes.afterShowElements.map(i => '.' + i + '.' + options.classes.show).join(', '));

            this._shownObserver =
                new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        let sdir = scrollStore.getData().dir;
                        if (entry.isIntersecting) {
                            entry.target.classList.remove(options.classes.gone);
                        }
                        else if (sdir === 'down') {
                            entry.target.classList.add(options.classes.gone);
                        }
                    });
                }, { threshold: .05 });

            this._shownElements.forEach(element => {
                this._shownObserver.observe(element);
            });
        }
    }

    disconnectIntersection() {
        if (this._observer)
            this._observer.disconnect();
    }
    handleDispatcher(e) {

    }
}

const instance = new ScrollIntersectionAnimation();

export default {
    init: instance.init,
    destroy: instance.destroy,
};
